import { dispatcher } from 'src/utils/dispatcher';
import { routeChanged } from 'src/app/actions';

// dispatch an action to tell all the stores that the route is changes
// so they have a chance to reset their data if necessary
export const onRouteChange = () => dispatcher.handleDispatch(routeChanged());
